import { z } from "zod";

export const create = z.object({
  model: z.string().min(1, "Required"),
  manufacturer: z.string().min(1, "Required"),
  ref: z.string().nullish(),
  serialNumber: z.string().nullish(),
});

export const update = create.extend({ id: z.number() });
